import { worldFlagUrl } from '@/common/assets';
import { useTheme } from '@/common/hooks';
import { T } from '@/common/enums';
import type { JerseyProps } from './Jersey.types';
import { getJerseyDimensions } from './getJerseyDimensions';
import { EmptyJersey } from './EmptyJersey';
import overlayDarkUrl from './assets/Overlay_dark.svg?url';
import overlayLightUrl from './assets/Overlay_light.svg?url';

export default function Jersey(props: JerseyProps) {
  const {
    jerseySrc,
    size = 82,
    withOverlay = false,
    flagSrc,
    flagSrcMissingBehavior = 'empty',
    className = '',
  } = props;

  const { theme } = useTheme();
  const resolvedOverlaySrc = theme === T.DARK ? overlayDarkUrl : overlayLightUrl;

  const hasJersey = !!jerseySrc;
  const hasNonEmptyFlagSrc = !!flagSrc?.trim();
  const is32WithIcon = size === 32 && hasJersey;
  const emptyStateIconLayout = size === 32 && hasNonEmptyFlagSrc;
  const { width: jerseyW, height: jerseyH } = getJerseyDimensions(size);
  const overlayHeight = jerseyH * 0.685;
  const containerSize = is32WithIcon || emptyStateIconLayout ? 35 : size;

  function renderCornerFlag() {
    const cornerFlagImgClass = 'block w-full h-full object-contain';
    if (hasNonEmptyFlagSrc) {
      return <img src={flagSrc} alt="" className={cornerFlagImgClass} />;
    }
    if (flagSrcMissingBehavior === 'world') {
      return <img src={worldFlagUrl} alt="" className={cornerFlagImgClass} />;
    }
    return null;
  }

  return (
    <div
      className={`relative shrink-0 ${className}`}
      style={{ width: containerSize, height: containerSize }}
    >
      {!hasJersey ? (
        <EmptyJersey size={size} is32WithIconLayout={emptyStateIconLayout} />
      ) : (
        <>
          <div
            className={is32WithIcon ? 'absolute left-0 top-0' : 'relative w-full h-full'}
            style={{ width: jerseyW, height: jerseyH }}
          >
            <img
              alt=""
              className="absolute inset-0 max-w-none object-contain pointer-events-none w-full h-full"
              src={jerseySrc}
            />
            {withOverlay && (
              <img
                src={resolvedOverlaySrc}
                alt=""
                className="absolute left-0 bottom-0 pointer-events-none w-full max-w-none object-cover object-bottom"
                style={{ height: overlayHeight }}
              />
            )}
          </div>
          {is32WithIcon && (
            <div
              className="absolute right-0 bottom-0 w-4 h-4 flex items-center justify-center"
              aria-hidden
            >
              {renderCornerFlag()}
            </div>
          )}
        </>
      )}
    </div>
  );
}
